import { memo, useCallback } from 'react';
import GradientProgressBarAnimated from './GradientProgressBarAnimated';
import UserHint from '../../UserHints/components/UserHint';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { DemoLimitsHintStyled } from './styled/DemoLimitsHintStyled';
import { useDispatch, useSelector } from 'react-redux';
import { userHintsSlice } from '../../UserHints/userHintsReducer';
import classNames from 'classnames';
import { getIsLocationPlatformMobileSelector } from '../../Location/locationSelectors';
import { USER_HINTS } from '../../UserHints/userHints.constants';

interface IDemoLimitsHintProps {
}

function DemoLimitsHint(props: IDemoLimitsHintProps) {
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const isPlatformMobile = useSelector(getIsLocationPlatformMobileSelector);

    const hideHint = useCallback(() => {
        dispatch(userHintsSlice.actions.setDemoLimitsHintShownAction(false));
        dispatch(userHintsSlice.actions.initAddUserHintAction(USER_HINTS.DEMO_LIMITS));
    }, [dispatch]);

    return <DemoLimitsHintStyled>
        <GradientProgressBarAnimated/>
        <div className={classNames('hint-wrapper', { mobile: isPlatformMobile })}>
            <UserHint onButtonClick={hideHint} avatarPosition={'top'}>
                <span>{getLangPath('demo_limits.hint_welcome')}</span>
                <br/>
                <span>{getLangPath('demo_limits.hint_enjoy')}</span>
            </UserHint>
        </div>
    </DemoLimitsHintStyled>;
}

export default memo(DemoLimitsHint);